var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiosk-container-v2"},[_c('router-view',{ref:"activeView"}),_c('IdleTimeoutOverlay',{attrs:{"show":_vm.showIdleOverlay,"seconds-left":_vm.countdownSeconds},on:{"stay":_vm.cancelIdleCountdown,"leave":_vm.exitToHome}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }